.ProseMirror {
	padding: 0 !important;
	margin: 0 !important;
}

.ProseMirror > * {
	margin: 0 !important;
	padding: 0 !important;
}

.custom-highlight {
	background-color: yellow;
	padding: 2px 4px;
	border-radius: 4px;
}

.hide-highlight-brace {
	display: none;
}
